// Theme: golden-ratio
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'golden-ratio',
  name: 'GOLDEN RATIO',
  tagline: 'GOLDEN RATIO',
  description: 'Dourado da proporcao aurea com assinatura premium.',
  category: 'premium-status',
  tier: 'legendary',
  basePrice: 5250,
  swatches: ['#0A0E16', '#181C28', '#FBBF24', '#FEF3C7'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 14px 34px rgba(0, 0, 0, 0.30)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 58%, transparent)'
    },
    shellClasses: 'font-mono theme-golden-ratio'
  },
  colorVars: {
    '--accent': '#FBBF24',
    '--accent-foreground': '#0A0E16',
    '--background': '#0A0E16',
    '--border': '#4A3A10',
    '--card': '#181C28',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 70%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEF3C7',
    '--card-glow': 'color-mix(in srgb, var(--primary) 12%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0E16',
    '--foreground': '#FEF3C7',
    '--hold-fill': '#FBBF24',
    '--input': '#4A3A10',
    '--modal-bg': '#0A0E16',
    '--modal-border': '#4A3A10',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 34px rgba(0, 0, 0, 0.30)',
    '--muted': '#4A3A10',
    '--muted-foreground': '#FEF3C7',
    '--nav-active': '#FBBF24',
    '--nav-bg': '#181C28',
    '--popover': '#181C28',
    '--popover-foreground': '#FEF3C7',
    '--primary': '#FBBF24',
    '--primary-foreground': '#0A0E16',
    '--ring': '#FBBF24',
    '--secondary': '#4A3A10',
    '--secondary-foreground': '#FEF3C7',
    '--streak': '#FBBF24',
    '--success': '#22c55e',
    '--success-foreground': '#0A0E16',
    '--xp': '#FBBF24',
    '--xp-bg': '#181C28'
  },
  resolvedVars: {
    '--accent': '#FBBF24',
    '--accent-foreground': '#0A0E16',
    '--accent-foreground-hsl': '220 38% 6%',
    '--accent-foreground-oklch': 'from #0A0E16 l c h',
    '--accent-hsl': '43 96% 56%',
    '--accent-oklch': 'from #FBBF24 l c h',
    '--background': '#0A0E16',
    '--background-hsl': '220 38% 6%',
    '--background-oklch': 'from #0A0E16 l c h',
    '--border': '#4A3A10',
    '--border-hsl': '43 64% 18%',
    '--border-oklch': 'from #4A3A10 l c h',
    '--border-w': '1px',
    '--card': '#181C28',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 70%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEF3C7',
    '--card-foreground-hsl': '48 96% 89%',
    '--card-foreground-oklch': 'from #FEF3C7 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 12%, transparent)',
    '--card-hsl': '225 25% 13%',
    '--card-oklch': 'from #181C28 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0E16',
    '--destructive-foreground-hsl': '220 38% 6%',
    '--destructive-foreground-oklch': 'from #0A0E16 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FEF3C7',
    '--foreground-hsl': '48 96% 89%',
    '--foreground-oklch': 'from #FEF3C7 l c h',
    '--hold-fill': '#FBBF24',
    '--hold-fill-hsl': '43 96% 56%',
    '--hold-fill-oklch': 'from #FBBF24 l c h',
    '--input': '#4A3A10',
    '--input-hsl': '43 64% 18%',
    '--input-oklch': 'from #4A3A10 l c h',
    '--modal-bg': '#0A0E16',
    '--modal-bg-hsl': '220 38% 6%',
    '--modal-bg-oklch': 'from #0A0E16 l c h',
    '--modal-border': '#4A3A10',
    '--modal-border-hsl': '43 64% 18%',
    '--modal-border-oklch': 'from #4A3A10 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 34px rgba(0, 0, 0, 0.30)',
    '--muted': '#4A3A10',
    '--muted-foreground': '#FEF3C7',
    '--muted-foreground-hsl': '48 96% 89%',
    '--muted-foreground-oklch': 'from #FEF3C7 l c h',
    '--muted-hsl': '43 64% 18%',
    '--muted-oklch': 'from #4A3A10 l c h',
    '--nav-active': '#FBBF24',
    '--nav-active-hsl': '43 96% 56%',
    '--nav-active-oklch': 'from #FBBF24 l c h',
    '--nav-bg': '#181C28',
    '--nav-bg-hsl': '225 25% 13%',
    '--nav-bg-oklch': 'from #181C28 l c h',
    '--popover': '#181C28',
    '--popover-foreground': '#FEF3C7',
    '--popover-foreground-hsl': '48 96% 89%',
    '--popover-foreground-oklch': 'from #FEF3C7 l c h',
    '--popover-hsl': '225 25% 13%',
    '--popover-oklch': 'from #181C28 l c h',
    '--primary': '#FBBF24',
    '--primary-foreground': '#0A0E16',
    '--primary-foreground-hsl': '220 38% 6%',
    '--primary-foreground-oklch': 'from #0A0E16 l c h',
    '--primary-hsl': '43 96% 56%',
    '--primary-oklch': 'from #FBBF24 l c h',
    '--radius': '14px',
    '--ring': '#FBBF24',
    '--ring-hsl': '43 96% 56%',
    '--ring-oklch': 'from #FBBF24 l c h',
    '--secondary': '#4A3A10',
    '--secondary-foreground': '#FEF3C7',
    '--secondary-foreground-hsl': '48 96% 89%',
    '--secondary-foreground-oklch': 'from #FEF3C7 l c h',
    '--secondary-hsl': '43 64% 18%',
    '--secondary-oklch': 'from #4A3A10 l c h',
    '--shadow-card': '0 14px 34px rgba(0, 0, 0, 0.30)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 58%, transparent)',
    '--streak': '#FBBF24',
    '--streak-hsl': '43 96% 56%',
    '--streak-oklch': 'from #FBBF24 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A0E16',
    '--success-foreground-hsl': '220 38% 6%',
    '--success-foreground-oklch': 'from #0A0E16 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(43 96% 56% / 0.15)',
    '--xp': '#FBBF24',
    '--xp-bg': '#181C28',
    '--xp-bg-hsl': '225 25% 13%',
    '--xp-bg-oklch': 'from #181C28 l c h',
    '--xp-hsl': '43 96% 56%',
    '--xp-oklch': 'from #FBBF24 l c h'
  }
}
